/* eslint-disable @typescript-eslint/no-explicit-any */
import TextField from '@/shared/components/TextField/TextField'
import { currencySymbol } from '@/shared/utils/price'
import styles from './TagInput.module.scss'

interface TagInputProps {
  label: string
  field?: any
  value?: any
  onChange?: (...event: any[]) => void
  onBlur?: () => void
  name?: string
  inputRef?: (instance: HTMLInputElement | null) => void
  hasError?: boolean
}

function TagInput(props: TagInputProps) {
  const { label, hasError } = props
  const endAdornment = (
    <p className={`${styles.tagInputEndAdornment} body-medium`}>
      {currencySymbol()}
    </p>
  )
  return (
    <div className={styles.tagInputWrapper}>
      <div className={styles.tagInputLabelWrapper}>
        <p className={`body-bold-small ${styles.tagInputLabel}`}>{label}</p>
      </div>
      <TextField
        {...props}
        hasError={hasError}
        isTagInput
        endAdornment={endAdornment}
      />
    </div>
  )
}

export default TagInput
